/**
 * Component ids stored on page.data when the builder adds an elastic item.
 *
 * Page sections use buildable-* (the section picker sends editable-*, and the
 * editor rewrites those). Blocks inside an elastic section stay editable-*.
 * The site matches those ids literally (editable-subtitle, editable-heading, …).
 */

export const AGENT_HTML_ELASTIC_COMPONENT_ID = 'buildable-agent-html'

export const ELASTIC_SECTION_COMPONENT_IDS = Object.freeze([
	'buildable-cards',
	'buildable-complexes-list',
	'buildable-contact-us',
	'buildable-contact-us-mgmt',
	'buildable-directions',
	'buildable-discounts',
	'elastic-section',
	'buildable-expansion-panels',
	'buildable-full-width-embedded',
	'buildable-icon-cards',
	'buildable-gallery',
	'buildable-photo-cards',
	'buildable-photo-list',
	'buildable-questions',
	'buildable-testimonials',
	'buildable-units-list',
	AGENT_HTML_ELASTIC_COMPONENT_ID,
])

/** Children of an elastic section. Not page sections; do not rewrite to buildable-*. */
export const ELASTIC_INNER_COMPONENT_IDS = Object.freeze([
	'editable-heading',
	'editable-subtitle',
	'editable-text',
	'editable-rich-text',
	'editable-button',
	'editable-media',
])

/**
 * Page-section persistence: editable-* → buildable-*; lowercase.
 * Do not use this for blocks inside an elastic section.
 * @param {string} raw
 * @returns {string}
 */
export function normalizeElasticComponentType(raw) {
	const s = String(raw || '').trim()
	if (!s) return ''
	let out = s
	if (/^editable-/i.test(out)) {
		out = `buildable-${out.slice(9)}`
	}
	return out.toLowerCase()
}

/**
 * @param {string} raw
 * @returns {boolean}
 */
export function isAllowedElasticComponentType(raw) {
	const n = normalizeElasticComponentType(raw)
	return n !== '' && ELASTIC_SECTION_COMPONENT_IDS.includes(n)
}

/**
 * Id to persist for an elastic add.
 * Inner blocks keep their editable-* id. Page sections are stored as buildable-*.
 * @param {string} raw
 * @returns {{ ok: true, component: string } | { ok: false, component: string }}
 */
export function resolveStoredElasticComponent(raw) {
	const original = String(raw || '').trim().toLowerCase()
	if (!original) {
		return { ok: false, component: '' }
	}
	if (ELASTIC_INNER_COMPONENT_IDS.includes(original)) {
		return { ok: true, component: original }
	}
	const normalized = normalizeElasticComponentType(original)
	if (normalized && ELASTIC_SECTION_COMPONENT_IDS.includes(normalized)) {
		return { ok: true, component: normalized }
	}
	return { ok: false, component: original }
}
